//import logger from './logger';
import thunk from 'redux-thunk';
import { applyMiddleware } from 'redux';

let middlewares = [thunk];
if (process.env.NODE_ENV !== "production") {
  const logger = require("./logger").default; // Use `require` to avoid import execution in production
  middlewares.push(logger);
}

export default applyMiddleware(...middlewares);
